import { combineReducers } from 'redux'

import user from 'react-redux/reducers/user'
import app from 'react-redux/reducers/app'
//import user from 'reducers/user'

import asset from 'react-redux/reducers/asset'

import brand from 'react-redux/reducers/brand'
import dragAndDrop from 'react-redux/reducers/drag-and-drop'
import modal from 'react-redux/reducers/modal'
import playlist from 'react-redux/reducers/playlist'
import mediaPlayer from 'react-redux/reducers/media-player'
import highlight from 'react-redux/reducers/highlight'
import notification from 'react-redux/reducers/notification'
/*
import userAdministration from 'react-redux/reducers/user-administration'
import organizationAdministration from 'react-redux/reducers/organization-administration'*/


const main = combineReducers({
  brand,
  user,
  app,
  dragAndDrop,
  modal,
  asset,
  playlist,
  mediaPlayer,
  highlight,
  notification,
})

export default main



// WEBPACK FOOTER //
// ./src/app/react-redux/reducers/main.js